import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

export const useCustomBodyBackground = (resolveBackground) => {
    const {pathname} = useLocation()

    useEffect(() => {
        const background = resolveBackground?.(pathname)
        if (background) document.body.style.setProperty(bodyBackgroundVar, background)
        else document.body.style.removeProperty(bodyBackgroundVar)

        return () => document.body.style.removeProperty(bodyBackgroundVar)
    }, [pathname, resolveBackground])
}

const bodyBackgroundVar = '--custom-body-background'
